import { Logout } from "../Logout/Logout";
import { Sidebar } from "../Sidebar/Sidebar";
import ContextConstructor from "../Context/Context";
import sendLogError from "../../sendLogError";

import Avatar from "react-avatar";
import Popup from "reactjs-popup";
import { withRouter } from "react-router-dom";
import Drawer from "react-motion-drawer";
import { NavLink } from "react-router-dom";
import React, { Component } from "react";


import { QuotasStatus } from "./QuotasStatus";
import GestorPopup from "../Sidebar/GestorPopup";
import MAVOAPopup from "../Sidebar/MAVOAPopup";
import MusicaolicosPopup from "../Sidebar/MusicaolicosPopup";
import CampanhaMenoresPopup from "../Sidebar/CampanhaMenoresPopup";
import CampanhaReformaPopup from "../Sidebar/CampanhaReformaPopup";
import TermsAndConditionsPopup from "../Sidebar/TermsAndConditionsPopup";
import MyMontepioAppPopup from "../Sidebar/MyMontepioAppPopup";
import MyMontepioAdventoPopup from "../Sidebar/MyMontepioAdventoPopup";
import MyMontepioAlteracaoRegulamentoPopup from "../Sidebar/MyMontepioAlteracaoRegulamentoPopup";
import SubscricaoReforcoPopup from "../Sidebar/SubscricaoReforcoPopup";

//imagens

import pref from "../../images/pref.png";
import add_person from "../../images/add_person.png";
import alertaCircle from "../../images/alertaCircle.png";
import logoMobile from "../../images/logoMobile.png";
import pdfIcon from "../../images/pdfIcon.png";
import download from "../../images/download.png";
import hasnotification from "../../images/hasnotification.svg";
import nonotification from "../../images/nonotification.svg";
import user from "../../images/user.svg";
import expand from "../../images/expand.png";
import burguerMenu from "../../images/burguerMenu.png";


import "./Navbar.css";

class DesktopNavbar extends Component {
    constructor(props) {
        super(props);
        this.routeChange = this.routeChange.bind(this);
    }

    state = {
        openLeft: false,
        openRight: false,
        drawerStyle: `
        {
            "background": "#F9F9F9",
            "boxShadow": "rgba(0, 0, 0, 0.188235) 0px 10px 20px, rgba(0, 0, 0, 0.227451) 0px 6px 6px"
        }`,
        relativeWidth: false,
        widthLogoutMenu: 380,
        widthSideMenu: 380,
        noTouchOpen: false,
        noTouchClose: false,
        name: "",
        /*profile: [],*/
        terms: [],
        hasNotification: false,
        loading: true,
        showVotarSide: true,
        actualDate: null,
        startDate: null,
        endDate: null,
        //canVote: null,
        //startDateBFTeaser: null,
        //endDateBFTeaser: null,
        //startDateBF: null,
        //  endDateBF: null,
        actualDateAVOA: null,
        endDateAVOA: null,
        startDateAVOA: null,
        associates: [],
        selectedUserClientID: "",
        isActualUser: "",
        showTermsPopup: false,
        termsData: null,
        isCheckingTerms: true,
        otherPopupsPending: [],
    };

    routeChange() {
        let path = "/profile";
        this.props.history.push(path);
    }

    async componentDidMount() {

        await this.checkTermsAndConditions();

        if (!this.state.showTermsPopup) {
            this.initializeOtherComponents();
        }
    }

    async checkTermsAndConditions() {
        try {
            const { idToken } = this.context;

            const headers = {
                Authorization: `Bearer ${idToken}`
            };

            const response = await fetch("/Profile/GetTermsStatus", {
                method: "GET",
                headers
            });

            if (!response.ok) {
                throw new Error(`Erro HTTP: ${response.status}`);
            }

            const termsStatus = await response.json();

            if (termsStatus.requiresAcceptance) {
                this.setState({
                    showTermsPopup: true,
                    termsData: termsStatus,
                    isCheckingTerms: false
                });
            } else {
                this.setState({
                    isCheckingTerms: false
                });
            }

        } catch (error) {
            console.error("Error checking terms:", error);

            this.setState({
                isCheckingTerms: false
            });

            sendLogError(error.message, "checkTermsAndConditions");
        }
    }

    handleCloseTerms = () => {
        this.setState({
            showTermsPopup: false,
            termsData: null
        }, () => {
            this.initializeOtherComponents();
        });
    }

    handleAcceptTerms = async (optInsAccepted) => {
        try {
            const { idToken } = this.context;

            const headers = {
                Authorization: `Bearer ${idToken}`,
                'Content-Type': 'application/json'
            };

            const payload = {
                termsId: this.state.termsData.termsId,
                version: this.state.termsData.currentVersion,
                optInsAccepted: optInsAccepted
            };

            const response = await fetch("/Profile/AcceptTerms", {
                method: "POST",
                headers,
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                throw new Error(`Erro HTTP: ${response.status}`);
            }

            this.setState({
                showTermsPopup: false,
                termsData: null
            }, () => {
                this.initializeOtherComponents();
            });

        } catch (error) {
            console.error("Error accepting terms:", error);

            sendLogError(error.message, "handleAcceptTerms");
        }
    };

    initializeOtherComponents() {

        this.getAVOApopup();
        this.getTermsLink();
        this.populateProfileData();

        setTimeout(() => {
            this.getManagerInfo();
        }, 2000);

        if (
            this.context.selectedUserID !== "" &&
            this.context.selectedUserID !== undefined &&
            this.context.selectedUserID !== null &&
            this.manager &&
            this.manager.employeeNumber === "" &&
            this.manager.employeeNumber === null
        ) {
            this.getNotificationStatus();
        }
    }

    async getAVOApopup() {
        try {
            const { showTermsPopup, otherPopupsPending } = this.state;

            if (showTermsPopup) {
                this.setState({
                    otherPopupsPending: [...otherPopupsPending, "AVOA"]
                });
                return;
            }

            const { idToken } = this.context;

            const headers = {
                Authorization: `Bearer ${idToken}`,
            };

            const response = await fetch("/Elections/GetAVOADates", { headers });

            if (!response.ok) {
                throw new Error(`Erro HTTP: ${response.status}`);
            }

            const data = await response.json();

            // validação defensiva
            if (!data?.actualDateAVOA || !data?.startDateAVOA || !data?.endDateAVOA) {
                throw new Error("Dados inválidos (AVOA)");
            }

            this.setState({
                actualDateAVOA: data.actualDateAVOA,
                startDateAVOA: data.startDateAVOA,
                endDateAVOA: data.endDateAVOA,
            });

            const showedAVOAPopup = window.sessionStorage.getItem("showedAVOAPopup");

            const AVOAstart = new Date(data.startDateAVOA);
            const AVOAend = new Date(data.endDateAVOA);
            const AVOAactual = new Date(data.actualDateAVOA);

            if (AVOAactual > AVOAstart && AVOAactual < AVOAend) {
                if (showedAVOAPopup !== "true" && !showTermsPopup) {
                    document.getElementById("popupSubscricaoReforco")?.click();

                    // opcional: ativar se precisares evitar repetição
                    // window.sessionStorage.setItem("showedAVOAPopup", "true");
                }
            }

        } catch (error) {
            console.error("Error fetching AVOA popup:", error);

            sendLogError(error.message, "getAVOApopup");
        }
    }

    setWidth = (e) => {
        this.setState({
            width: Number(e.target.value) || e.target.value,
        });
    };

    setTouch = (e) => {
        this.setState({
            [e.target.name]: !e.target.checked,
        });
    };

    setDrawerStyle = (e) => {
        e.preventDefault();
        this.setState({
            drawerStyle: this.drawerStyleRef.value,
        });
    };

    getInitials = (name) => {
        if (!name || typeof name !== "string") {
            return "D U";
        }

        var names = name.split(" ");
        let x = names[0][0] + " " + names[names.length - 1][0];
        return x;
    };

    getNameCapitalize = (name) => {
        if (typeof name !== "string" || !name.trim()) {
            return "";
        }

        return name
            .toLowerCase()
            .split(" ")
            .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
            .join(" ");
    };

    utf8Decode(utf8String) {
        if (typeof utf8String != "string")
            throw new TypeError("parameter 'utf8String' is not a string");
        const unicodeString = utf8String
            .replace(
                /[\u00e0-\u00ef][\u0080-\u00bf][\u0080-\u00bf]/g,
                function (c) {
                    var cc =
                        ((c.charCodeAt(0) & 0x0f) << 12) |
                        ((c.charCodeAt(1) & 0x3f) << 6) |
                        (c.charCodeAt(2) & 0x3f);
                    return String.fromCharCode(cc);
                },
            )
            .replace(
                /[\u00c0-\u00df][\u0080-\u00bf]/g,
                function (c) {
                    var cc = ((c.charCodeAt(0) & 0x1f) << 6) | (c.charCodeAt(1) & 0x3f);
                    return String.fromCharCode(cc);
                },
            );
        return unicodeString;
    }

    closeMenuFunction = () => {
        this.setState({
            openLeft: false,
            openRight: false,
        });
    };

    switchToAssociateUser = (associate) => {
        this.setState({
            openLeft: false,
            openRight: false,
            name: this.getNameCapitalize(associate.name),
        });

        this.context.changeselectedUserID(associate);
        this.getManagerInfo();
    };

    profileButtons() {
        if (this.context.tokenUser === this.context.selectedUserID) {
            return (
                <div>
                    <NavLink to="/profile" style={{ textDecoration: "none" }}>
                        <div onClick={this.closeMenuFunction} className="dadosconta-button">
                            <div>Os seus dados</div>
                            <img src={pref} alt="" width="26px" height="´26px" />
                        </div>
                    </NavLink>
                    <NavLink to="/profile?activeTab=tab2" style={{ textDecoration: "none" }}>                        
                    </NavLink>
                </div>
            );
        } else {
            return "";
        }
    }

    buttonAddMenor() {
        if (this.context.tokenUser === this.context.selectedUserID) {
            return (
                <NavLink to="/AdicionaMenor" style={{ textDecoration: "none" }}>
                    <div onClick={this.closeMenuFunction} className="adicionaassociadomenor">
                        <img src={add_person} alt="" width="26px" height="´26px" />
                        <div style={{ marginTop: "15px", marginLeft: "7px" }}>
                            Adicionar Criança ou Jovem Associado
                        </div>
                    </div>
                </NavLink>
            );
        } else {
            return "";
        }
    }

    getSafeDisplayName = (name) => {
        if (typeof name !== "string") return "";
        return this.getNameCapitalize(name);
    };

    displayAssociadosMenores() {
        let menores = (
            <div>
                {this.context.mymUsers
                    .filter((associate) => {
                        return associate.clientID !== this.context.selectedUserID;
                    })
                    .map((associate, i) => {
                        const safeName = this.getSafeDisplayName(associate?.name);

                        if (associate.associateState == "CONDICIONADO") {
                            return (
                                <NavLink to="/" style={{ textDecoration: "none" }}>
                                    <div onClick={() => this.switchToAssociateUser(associate)}>
                                        <hr />
                                        <div style={{ textAlign: "left" }}>
                                            <Avatar
                                                color={"#E0E0E0"}
                                                name={safeName}
                                                round={true}
                                                size={40}
                                            />
                                            <label
                                                style={{
                                                    fontWeight: "bold",
                                                    color: "gray",
                                                    paddingTop: "5px",
                                                    marginLeft: "10px",
                                                    display: "inline",
                                                }}>
                                                {safeName}
                                            </label>
                                            <img
                                                src={alertaCircle}
                                                width="20px"
                                                height="20px"></img>
                                        </div>
                                        <hr />
                                    </div>
                                </NavLink>
                            );
                        } else {
                            return (
                                <NavLink to="/" style={{ textDecoration: "none" }}>
                                    <div onClick={() => this.switchToAssociateUser(associate)}>
                                        <hr />
                                        <div style={{ textAlign: "left" }}>
                                            <Avatar
                                                color={"#E0E0E0"}
                                                name={safeName}
                                                round={true}
                                                size={40}
                                            />
                                            <label
                                                style={{
                                                    fontWeight: "bold",
                                                    color: "gray",
                                                    paddingTop: "5px",
                                                    marginLeft: "10px",
                                                    display: "inline",
                                                }}>
                                                {safeName}
                                            </label>
                                        </div>
                                        <hr />
                                    </div>
                                </NavLink>
                            );
                        }
                    })}
            </div>
        );

        const buttonAddMenor = () => {
            if (this.context.tokenUser === this.context.selectedUserID) {
                return (
                    <NavLink to="/AdicionaMenor" style={{ textDecoration: "none" }}>
                        <div onClick={this.closeMenuFunction} className="adicionaassociadomenor">
                            <img
                                src={add_person}
                                alt=""
                                width="26px"
                                height="´26px"
                            />
                            <div style={{ marginTop: "15px", marginLeft: "7px" }}>
                                Adicionar Criança ou Jovem Associado
                            </div>
                        </div>
                    </NavLink>
                );
            } else {
                return "";
            }
        };

        return (
            <div>
                {menores}
                {buttonAddMenor()}
            </div>
        );
    }

    render() {
        const {
            drawerStyle: stringDrawerStyle,
            openLeft,
            openRight,
            noTouchOpen,
            name,
            noTouchClose,
        } = this.state;

        let drawerStyle = {};
        try {
            drawerStyle = JSON.parse(stringDrawerStyle);
        } catch (err) {
            console.error("Error parsing JSON: ", err);
        }

        const drawerProps = {
            overlayColor: "rgba(255,255,255,0.6)",
            drawerStyle,
        };

        let termsAndConditionsPopup = null;
        if (this.state.showTermsPopup && this.state.termsData) {
            termsAndConditionsPopup = (
                <TermsAndConditionsPopup
                    termsData={this.state.termsData}
                    close={this.handleCloseTerms}
                    onAccept={this.handleAcceptTerms}
                    onClose={this.handleCloseTerms}
                />
            );
        }

        let popupCampanhaReformCarolina = (
            <Popup
                trigger={
                    <div id="popupCampanhaReformCarolina" style={{ display: "none" }}></div>
                }
                modal
                closeOnDocumentClick={!this.state.showTermsPopup}
                contentStyle={{ background: "none", border: "none" }}
            >
                {(close) => (
                    <CampanhaReformaPopup
                        close={close}
                    />
                )}
            </Popup>
        );

        let popupCampanhaMyMontepioApp = (
            <Popup

                trigger={
                    <div id="popupCampanhaMyMontepioApp" style={{ display: "none" }}></div>
                }
                modal
                closeOnDocumentClick
                contentStyle={{ background: "none", border: "none" }}
            >
                {(close) => (
                    <MyMontepioAppPopup
                        close={close}
                    />
                )}
            </Popup>
        );

        let popupCampanhaMyMontepioAdvento = (
            <Popup

                trigger={
                    <div id="popupCampanhaMyMontepioAdvento" style={{ display: "none" }}></div>
                }
                modal
                closeOnDocumentClick
                contentStyle={{ background: "none", border: "none" }}
            >
                {(close) => (
                    <MyMontepioAdventoPopup
                        close={close}
                    />
                )}
            </Popup>
        );

        let popupCampanhaMyMontepioAlteracaoRegulamento = (
            <Popup

                trigger={
                    <div id="popupCampanhaMyMontepioAlteracaoRegulamento" style={{ display: "none" }}></div>
                }
                modal
                closeOnDocumentClick
                contentStyle={{ background: "none", border: "none" }}
            >
                {(close) => (
                    <MyMontepioAlteracaoRegulamentoPopup
                        close={close}
                    />
                )}
            </Popup>
        );
        let popupSubscricaoReforco = (
            <Popup
                trigger={
                    <div id="popupSubscricaoReforco" style={{ display: "none" }}></div>
                }
                modal
                closeOnDocumentClick
                contentStyle={{ background: "none", border: "none" }}
            >
                {(close) => (
                    <SubscricaoReforcoPopup
                        close={close}
                    />
                )}
            </Popup>
        );
        let popupCampanhaMenoresCarolina = (
            <Popup
                className="popupCampanhaMenoresCarolina"
                trigger={
                    <div id="popupCampanhaMenoresCarolina" style={{ display: "none" }}></div>
                }
                modal
                closeOnDocumentClick={!this.state.showTermsPopup}
                contentStyle={{ background: "none", border: "none" }}
            >
                {(close) => (
                    <CampanhaMenoresPopup
                        close={close}
                    />
                )}
            </Popup>
        );

        let popupMusicaolicos = (
            <Popup
                className="popupMusicaolicos"
                trigger={
                    <div id="popupMusicaolicos" style={{ display: "none" }}></div>
                }
                modal
                closeOnDocumentClick={!this.state.showTermsPopup}
                contentStyle={{ background: "none", border: "none" }}
            >
                {(close) => (
                    <MusicaolicosPopup
                        close={close}
                    />
                )}
            </Popup>
        );

        let popupGestor = (
            <Popup
                trigger={<div id="popupGestorTrigger" style={{ display: "none" }}></div>}
                modal
                closeOnDocumentClick={!this.state.showTermsPopup}
                contentStyle={{ background: "none", border: "none" }}>
                {(close) => (
                    <GestorPopup
                        manager={this.state.manager}
                        close={close}
                        hasManager={this.state.hasManager}
                    />
                )}
            </Popup>
        );

        let popupMAVOA = (
            <Popup
                className="popupPrimaveraSound"
                trigger={<div id="popupMAVOATrigger" style={{ display: "none" }}></div>}
                modal
                closeOnDocumentClick={!this.state.showTermsPopup}
                contentStyle={{ background: "none", border: "none" }}>
                {(close) => <MAVOAPopup close={close} />}
            </Popup>
        );

        return (
            <div>
                {termsAndConditionsPopup}
                {!this.state.showTermsPopup && (
                    <>
                        {popupGestor}
                        {popupMusicaolicos}
                        {popupMAVOA}
                        {popupCampanhaMenoresCarolina}
                        {popupCampanhaReformCarolina}
                        {popupCampanhaMyMontepioApp}
                        {popupCampanhaMyMontepioAdvento}
                        {popupCampanhaMyMontepioAlteracaoRegulamento}
                        {popupSubscricaoReforco}
                    </>
                )}

                <div
                    className={
                        "navbar-div " +
                        (this.state.openRight || this.state.openLeft ? "absolute" : "")
                    }
                    style={{
                        filter: this.state.showTermsPopup ? 'blur(5px)' : 'none',
                        pointerEvents: this.state.showTermsPopup ? 'none' : 'auto'
                    }}
                >
                    <div className="nav-logo">
                        <a href="/">
                            <img
                                src={logoMobile}
                                alt=""
                                height="45px"
                                className=""
                            ></img>
                        </a>
                    </div>
                    <ul className="nav-links">
                        <li>
                            <div className="drawer-wrapper">
                                {!openLeft && (
                                    <Drawer
                                        right
                                        width={this.state.widthLogoutMenu}
                                        {...drawerProps}
                                        open={openRight}
                                        onChange={(open) => this.setState({ openRight: open })}
                                        noTouchOpen={noTouchOpen}
                                        noTouchClose={noTouchClose}
                                        onClick={this.setProfileName}
                                        className="drawerStyle"
                                        overlayClassName="overlayStyle"
                                    >
                                        <div className="sidedrawer">
                                            <Logout />
                                            <div className="dadosconta">
                                                <Avatar
                                                    color={"#FF5800"}
                                                    name={this.state.name}
                                                    round={true}
                                                    size={120}
                                                />
                                                <div className="username">{/*{this.context.selectedUser.name}*/}
                                                    {this.state.name}
                                                    {/*{this.context.selectedUser.length > 0 && this.getNameCapitalize(this.context.selectedUser[0].name)}*/}
                                                </div>
                                                <QuotasStatus
                                                    selectedUserProfile={this.context.selectedUser}
                                                    closeMenuFunction={this.closeMenuFunction}
                                                ></QuotasStatus>

                                                {this.profileButtons()}

                                                {/* {this.displayAssociadosMenores()}*/}
                                            </div>
                                            <div className="downloads-wrapper">
                                                <div className="downloads-sidedrawer-text">DOWNLOADS</div>
                                                <div style={{ display: "flex", marginTop: "30px" }}>
                                                    <img
                                                        style={{ marginRight: "18px" }}
                                                        src={pdfIcon}
                                                        alt=""
                                                        height="26px"
                                                        width="26px"
                                                    />
                                                    <div>
                                                        <div className="glossary-title">Termos e Condições</div>
                                                        <a
                                                            className="glossary-download-button"
                                                            href={this.state.terms}
                                                            download="termosecondicoes.pdf"
                                                            target="_blank"
                                                            rel="noopener noreferrer">
                                                            <div>Clique aqui</div>
                                                            <img
                                                                src={download}
                                                                alt="Botão de Download"
                                                                height="7.5px"
                                                                width="7.2px"
                                                            />
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Drawer>
                                )}
                                <div className="navbar-icons-div">
                                    <NavLink
                                        to="/notificacoes"
                                        activeClassName="navbar-icons-single-active"
                                        className="navbar-icons-single">
                                        {this.state.hasNotification ? (
                                            <img
                                                src={hasnotification}
                                                id="notificationbell"
                                                alt="Com  Notificaçōes"
                                                className="profile"
                                            />
                                        ) : (
                                            <img
                                                src={nonotification}
                                                id="notificationbell"
                                                alt="Sem  Notificaçōes"
                                                className="profile"
                                            />
                                        )}
                                    </NavLink>
                                    <a
                                        className={
                                            this.props.location.pathname == "/profile"
                                                ? "navbar-icons-single-active"
                                                : "navbar-icons-single"
                                        }
                                        onClick={() => this.setState({ openRight: !openRight, openLeft: false })}>
                                        <img src={user} alt="" className="profile" />
                                    </a>
                                </div>
                            </div>
                        </li>
                        <li className="name">
                            {/*{this.context.selectedUser.name}*/}
                            {this.state.name}
                            <a onClick={() => this.setState({ openRight: !openRight, openLeft: false })}>
                                <img
                                    src={expand}
                                    alt=""
                                    style={{
                                        width: "25px",
                                        paddingLeft: "10px",
                                    }}
                                />
                            </a>
                        </li>
                        <li className="burguer-menu">
                            <div>
                                {!openRight && (
                                    <Drawer
                                        {...drawerProps}
                                        width={this.state.widthSideMenu}
                                        fadeOut
                                        open={openLeft}
                                        onChange={(open) => this.setState({ openLeft: open })}
                                        noTouchOpen={noTouchOpen}
                                        noTouchClose={noTouchClose}
                                        className="drawer-side-menu">
                                        <Sidebar
                                            className="mobile-side-bar"
                                            closeMenuFunction={this.closeMenuFunction}
                                            manager={this.state.manager}
                                            hasManager={this.state.hasManager}
                                        />
                                    </Drawer>
                                )}
                                <a onClick={() => this.setState({ openLeft: !openLeft, openRight: false })}>
                                    <img
                                        src={burguerMenu}
                                        alt="Sidedrawer"
                                        className="burguer-menu-icon"></img>
                                </a>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        );
    }

    async populateProfileData() {
        const selectedUser = this.context.selectedUser;

        if (!selectedUser || !selectedUser.name) {
            return;
        }

        const profileName = selectedUser.name;
        const profileNameUTF8 = this.getNameCapitalize(
            this.utf8Decode(profileName)
        );

        this.setState({ name: profileNameUTF8, loading: false });
    }

    async getTermsLink() {
        try {
            const { idToken } = this.context;

            const headers = {
                Authorization: `Bearer ${idToken}`,
            };

            const response = await fetch("/Auth/GetTermsLink", { headers });

            if (!response.ok) {
                throw new Error(`Erro HTTP: ${response.status}`);
            }

            const data = await response.json();
            const termsLink = data?.value;

            this.setState({ terms: termsLink });

        } catch (error) {
            console.error("Error fetching terms link:", error);

            sendLogError(error.message, "getTermsLink");
        }
    }

    async getNotificationStatus() {
        try {
            const { selectedUserID, idToken } = this.context;

            const headers = {
                Authorization: `Bearer ${idToken}`,
                clientId: selectedUserID,
            };

            const response = await fetch(
                `/Notifications/GetNotifications?ClientId=${selectedUserID}`,
                { headers }
            );

            if (!response.ok) {
                this.setState({hasNotification: false});
                return;
            }

            const data = await response.json();

            // verifica se existe alguma não lida
            const hasUnread = Array.isArray(data)
                ? data.some((item) => !item.isRead)
                : false;

            this.setState({
                hasNotification: hasUnread,
            });

        } catch (error) {
            console.error("Error fetching notifications:", error);

            this.setState({
                hasNotification: false
            });

            sendLogError(error.message, "getNotificationStatus");
        }
    }

    async getManagerInfo() {
        try {
            const { selectedUserID, idToken } = this.context;

            const headers = {
                Authorization: `Bearer ${idToken}`,
            };

            const response = await fetch(
                `/Profile/GetManager?ClientId=${selectedUserID}`,
                { headers }
            );

            if (!response.ok) {
                this.setState({
                    hasManager: false,
                    manager: null,
                    loading: false
                });

                return;
            }

            const data = await response.json();            
            const hasValidManager =
                data && (data.name || data.email || data.employeeNumber)

            this.setState({
                hasManager: !!hasValidManager,
                manager: hasValidManager ? data : null,
                loading: false
            });
        } catch (error) {
            console.error("Error fetching manager info:", error);

            this.setState({
                hasManager: false,
                loading: false
            });

            sendLogError(error.message, "getManagerInfo");
        }
    }

    async populateAssociateData() {
        try {
            const { idToken } = this.context;

            const headers = {
                Authorization: `Bearer ${idToken}`,
            };

            // Buscar associados
            const resAssociates = await fetch("/Profile/GetMymAssociates", { headers });

			if (!resAssociates.ok) {
				throw new Error(`Erro ao obter associados: ${resAssociates.status}`);
			}
			
			const data = await resAssociates.json();

			let parsed = [];

			try {
				parsed = data?.value ? JSON.parse(data.value) : [];
			} catch (e) {
				console.error("Erro a fazer parse de associados", e);
				parsed = [];
			}
			
            const associates = Array.isArray(parsed) ? parsed : [];

            // Buscar perfil do utilizador
			const resProfile = await fetch("/Profile/GetProfile", { headers });

			if (!resProfile.ok) {
				throw new Error(`Erro ao obter perfil: ${resProfile.status}`);
			}

			const userProfileResponse = await resProfile.json();
			
			const isValidProfile = userProfileResponse 
				&& Object.keys(userProfileResponse).length > 0 
				&& userProfileResponse.clientID;

            // Adicionar utilizador atual
            associates.push(userProfileResponse);

            let selectedUserClientID = "";

            if (isValidProfile) { 
                // Marcar token user
                associates.forEach((associated) => {
                    if (associated.clientID === userProfileResponse.clientID) {
                        associated.isTokenUser = true;
                        selectedUserClientID = associated.clientID;
                    } else {
                        associated.isTokenUser = false;
                    }
                });
            }

            // Atualizar estado
            this.setState({
                associates,
                loading: false,
                selectedUserClientID,
                isActualUser: userProfileResponse.clientID,
            });

            // Guardar em localStorage
            const montepioUser = {
                menores: associates,
                selectedUserClientID,
                isActualUser: userProfileResponse.clientID,
            };

            localStorage.setItem("montepioUser", JSON.stringify(montepioUser));

        } catch (error) {
            console.error("Error in populateAssociateData:", error);

            this.setState({ loading: false });

            sendLogError(error.message, "populateAssociateData");
        }
    }
}

DesktopNavbar.contextType = ContextConstructor;

export default withRouter(DesktopNavbar);